module.exports = __webpack_public_path__ + "static/media/logo-white.b5bac29c.png";